/**
 * The MultiSelector will manage a state variable in you're controlling components
 * state. This will allow multiple items to be selected. Meta-click will unselect
 * a selected item.
 * @property {Component} component the component whose state is managed
 * @property {string} stateKey the name of the selection group in the state
 * @property {object} options
 * @property {function} options.onSelect called with three arguemnts: the array
 * of the new selections ids, the item being added or removed, and true or false indicating
 * if the event is an add or remove. If this function returns false, the selection is cancelled. This will
 * be invoked prior to calling component.setState()
 * @property {function} [options.idFunc] a function used to return item's id. The id will be stored
 * in the selection group.
 * @property {string} [options.idKey] the key of the item's id. The id will be stored
 * in the selection group. This is unused if idFunc is supplied
 **/
export default class MultiSelector {
  constructor(component, stateKey, {
    onSelect,
    idFunc,
    idKey
  } = {}) {
    this.component = component;
    this.stateKey = stateKey;
    this.idKey = idKey;
    this.idFunc = idFunc;
    this.allowSelect = onSelect;
  }
  key(item) {
    if (this.idFunc) {
      return this.idFunc(item);
    }
    return this.idKey ? item[this.idKey] : item;
  }
  isSelected(item) {
    const key = this.key(item);
    let v = this.component.state[this.stateKey].includes(key);
    if (!v && typeof key === 'number') {
      v = this.component.state[this.stateKey].includes(`${key}`);
    }
    return v;
  }
  onSelect(event) {
    const item = event.value;
    const key = this.key(item);
    // const shift = event.sourceEvent && event.sourceEvent.shiftKey
    const meta = event.sourceEvent && event.sourceEvent.metaKey;
    // const alt = event.sourceEvent && event.sourceEvent.altKey
    const c = this.component.state[this.stateKey] || [];
    const index = c.indexOf(key);
    let add = true;
    let newSelection = null;
    if (index >= 0 && meta) {
      newSelection = [...c];
      newSelection.splice(index, 1);
      add = false;
    } else if (meta) {
      newSelection = [...c, key];
    } else {
      if (index === 0) {
        // already selected.
        return;
      }
      newSelection = [key];
    }
    if (this.allowSelect == null || this.allowSelect(newSelection, item, add) !== false) {
      const cb = event.onSelect ? () => {
        event.onSelect(newSelection);
      } : null;
      this.component.setState({
        [this.stateKey]: newSelection
      }, cb);
    }
  }
}